import { CanDeactivateFn } from '@angular/router';
import { ModuleFormComponent } from './module-form.component';

export const canDeactivateModuleForm: CanDeactivateFn<ModuleFormComponent> = (component) => {
  if (component.hasUnsavedChanges()) {
    return component.confirmDeactivate();
  }
  return true;
};
